<template>
  <div style="padding: 5px">
    <!--     IMAGE -->
    <div
      v-if="formData.image_url"
      class="upload_image">
      <img :src="formData.image_url" class="image_centered"/>
<!--      <div class="upload_image_cover">-->
<!--        <Icon type="ios-trash-outline" @click.native="deleteImage"></Icon>-->
<!--      </div>-->
    </div>

    <div>
      <div class="alert-msg">
        <div class="d-flex align-center">
          <img src="/static/svg/attention.svg" alt="" >
          <span>
                Допустимый формат изображений: png, jpg, jpeg. Максимальный размер - 1 Mb.
              </span>
        </div>
      </div>
      <Upload
        class="mb-30"
        type="drag"
        :action="upload_url"
        :headers="headers"
        :on-success="onSuccessImageUpload"
        :before-upload="onBeforeUpload"
        :format="['jpg','jpeg', 'png']"
      >
        <div style="padding: 20px 0">
          <Icon type="md-cloud-upload" size="50"/>
          <p>Загрузите изображение</p>
        </div>
      </Upload>
    </div>
  </div>
</template>

<script>
    import {base_url, server_addr, login_addr} from "../../http.js";

    export default {
        name: "companyLogo",

        data() {
          return {
            loading: true,
            // baseViewUrl: base_url + '/company/requisites/',
            baseViewUrl: base_url + "/proxy_/wcadmin/v1/logo",
            schema: {},
            rules: {},
            validForm: false,
            isChanged: false,
            upload_url: server_addr + "/proxy_/wcadmin/v1/logo",
            content_url: login_addr + '/content/v1/content/',
            company_content_url: server_addr + '/proxy_/wcadmin/v1/organizations',
            formData: {
              image_url: '',
              image: ''
            }
          }
        },

        computed: {
          // image_url_full: function () {
          //   return this.formData.image_url;
          // },
          token: function () {
            return this.$store.state.access_token;
          },
          headers: function () {
            return {
              Authorization: 'Bearer ' + this.token,
              // "Content-Type": 'image/jpeg'
              "Content-Type": 'application/json'
            }
          }
        },

        methods: {
          image_url_full: function (filename) {
            // return this.formData.image_url;
            return `${this.content_url}${filename}?timestamp=${Date.now()}`;
          },
          onSuccessImageUpload: function (response, file, fileList) {
            this.formData.image = response.resourceName;
            this.formData.image_url = this.image_url_full(response.resourceName);
          },
          deleteImage: function () {
            this.formData.image = "";
            this.formData.image_url = "";
          },

          onBeforeUpload: function (file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = e => {
              let _file = e.target.result;

              let data = {
                // 'contentType': 'image/jpeg',
                'contentType': file.type,
                // 'resourceExtension': 'jpeg',
                'resourceExtension': file.type.replace(/^image\//g, ""),
                "data": this._utf8_encode(_file)
              };

              data['data'] = data['data'].replace(/^data:.+;base64,/g, "");

              this.$http
                .post(this.upload_url, data, { headers: this.headers })
                .then(response => {
                  this.$Message.success("Успешно сохранено");

                  this.formData.image = response.data.resourceName;
                  // this.formData.image_url = `${this.content_url}${response.data.resourceName}?timestamp=${Date.now()}`;
                  this.formData.image_url =  this.image_url_full(response.data.resourceName);

                })
                .finally(() => {
                  this.loading = false;
                });

            };
            return false; // Prevent upload default upload
          },
          Base64Encode: function(str, encoding = 'utf-8') {
            var bytes = new (TextEncoder || TextEncoderLite)(encoding).encode(str);
            return base64js.fromByteArray(bytes);
          },

          _utf8_encode : function (string) {
            string = string.replace(/\r\n/g,"\n");
            var utftext = "";

            for (var n = 0; n < string.length; n++) {

              var c = string.charCodeAt(n);

              if (c < 128) {
                utftext += String.fromCharCode(c);
              }
              else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
              }
              else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
              }

            }

            return utftext;
          },



        },


        mounted: function(){
          // this.deleteImage();
          this.$http
            .get(this.company_content_url)
            .then(result => {
              // this.formData.image_url = `${this.content_url}${result.data.logoResourceName}?timestamp=${Date.now()}`;
              if (result.data.logoResourceName) {
                this.formData.image_url = this.image_url_full(result.data.logoResourceName);
                this.formData.image = result.data.logoResourceName;
              }
            })
        }
    }
</script>

<style scoped>
  .image_centered {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 300px;
  }

  .alert-msg {
    margin: 32px 0;
    /*width: 50%;*/
    min-width: 700px;
    border: none;
    background-color: #F1F1F1;
    font-size: 14px;
    color: rgba(14, 37, 74, 0.6);
    padding: 12px 20px;
    line-height: 1.5;
  }

  .alert-msg img {
    margin-right: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/apps/company/companyLogo.vue